module.exports = "/dist/fonts/fontawesome-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = 432
// module chunks = 0